import * as React from "react";
import { SVGProps, memo } from "react";

const SvgCompleteBorder = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M26.962 15.347a1.5 1.5 0 0 1 0 2.122l-7.038 7.038a2 2 0 0 1-2.828 0l-4.058-4.058a1.5 1.5 0 1 1 2.121-2.122l3.351 3.351 6.331-6.33a1.5 1.5 0 0 1 2.121 0Z"
      fill="#2BA168"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.036 20.236c0 8.837-7.163 16-16 16-8.836 0-16-7.163-16-16 0-8.836 7.164-16 16-16 8.837 0 16 7.164 16 16Zm-3 0c0 7.18-5.82 13-13 13s-13-5.82-13-13 5.82-13 13-13 13 5.82 13 13Z"
      fill="#2BA168"
    />
  </svg>
);

const Memo = memo(SvgCompleteBorder);

export default Memo;
